module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_m_erythristic.83f0ee29.png";